<template>
  <v-layout row wrap ma-0>
    <v-col md="6" sm="12" cols="12" class="pa-0 pa-0 pr-1">
      <v-row no-gutters>
        <v-col
          align-self-center
          text-start
          class="pt-0 pb-0"
          cols="auto"
          style="font-size: 18px; display:flex"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="align-self-center">
                {{ $t("components.duepicker.due_on") }}
              </span>

              <v-icon class="help-icon" v-bind="attrs" v-on="on">help</v-icon>
            </template>
            <span>{{ tooltips.dueon.text }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          v-if="value.DueDay === 'DayOfMonth'"
          class="pt-0 pb-0 pr-1"
          cols="12"
          sm="6"
        >
          <!-- <auto-select
            :value.sync="value.DayOfMonth"
            :items="daysOfMonth"
            :label="$t('components.duepicker.day_of_month')"
            :rules="dayOfMonthRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.day_of_month") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.DayOfMonth) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.DayOfMonth"
            :items="daysOfMonth"
            :label="$t('components.duepicker.day_of_month')"
            :rules="dayOfMonthRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
        <v-col
          v-if="value.DueDay === 'WeekDay'"
          class="pt-0 pb-0 pr-1"
          cols="12"
          sm="6"
        >
          <!-- <auto-select
            :value.sync="value.WeekDay"
            :items="weekDays"
            :label="$t('components.duepicker.week_day')"
            :rules="weekDayRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.week_day") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.WeekDay) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.WeekDay"
            :items="weekDays"
            :label="$t('components.duepicker.week_day')"
            :rules="weekDayRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
        <v-col class="pt-0 pb-0 pr-1" cols="12" sm="6">
          <!-- <auto-select
            :value.sync="value.DueDay"
            :items="dueDayItems()"
            :label="$t('components.duepicker.due_day')"
            :rules="dueDayRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.due_day") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.DueDay) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.DueDay"
            :items="dueDayItems()"
            :label="$t('components.duepicker.due_day')"
            :rules="dueDayRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
      </v-row>
    </v-col>

    <v-col md="6" sm="12" cols="12" class="pa-0 pa-0">
      <v-row no-gutters>
        <v-col
          align-self-center
          text-start
          class="pt-0 pb-0"
          style="font-size: 18px; display:flex"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="align-self-center">
                {{ $t("components.duepicker.of_terms") }}
              </span>

              <v-icon class="help-icon" v-bind="attrs" v-on="on">help</v-icon>
            </template>
            <span>{{ tooltips.dueon.text }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col v-if="value.DueTimeUnit === 'Week'" class="pt-0 pb-0 pr-1">
          <!-- <auto-select
            :value.sync="value.Week"
            :items="weeks"
            :label="$t('components.duepicker.week')"
            :rules="weekRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.week") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.Week) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.Week"
            :items="weeks"
            :label="$t('components.duepicker.week')"
            :rules="weekRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
        <v-col v-if="value.DueTimeUnit === 'Month'" class="pt-0 pb-0 pr-1">
          <!-- <auto-select
            :value.sync="value.Month"
            :items="months"
            :label="$t('components.duepicker.month')"
            :rules="monthRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.month") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.Month) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.Month"
            :items="months"
            :label="$t('components.duepicker.month')"
            :rules="monthRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
        <v-col
          v-if="termTimeUnit === 'Day' || termTimeUnit === 'Week'"
          class="pt-0 pb-0 pr-1"
        >
          <!-- <auto-select
            :value.sync="value.DueTimeUnit"
            :items="dueTimeUnitsWeek"
            :label="$t('components.duepicker.due_time_unit')"
            :rules="dueTimeUnitRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.due_time_unit") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.DueTimeUnit) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.DueTimeUnit"
            :items="dueTimeUnitsWeek"
            :label="$t('components.duepicker.due_time_unit')"
            :rules="dueTimeUnitRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
        <v-col v-if="termTimeUnit === 'Month'" class="pt-0 pb-0 pr-1">
          <!-- <auto-select
            :value.sync="value.DueTimeUnit"
            :items="dueTimeUnits"
            :label="$t('components.duepicker.due_time_unit')"
            :rules="dueTimeUnitRules"
            :disabled="disabled"
            :slots="true"
            :filter="filterFunc"
          >
            <template v-slot:selection="data">
              {{ $t("enums." + data.item) }}
            </template>
            <template v-slot:item="data">
              <v-list-item-content
                v-text="$t('enums.' + data.item)"
              ></v-list-item-content>
            </template>
          </auto-select> -->
          <template v-if="readOnly">
            {{ $t("components.duepicker.due_time_unit") }}
            <br />
            <span class="minfo">
              {{ $t("enums." + value.DueTimeUnit) }}
            </span>
          </template>
          <trans-enum
            v-else
            :value.sync="value.DueTimeUnit"
            :items="dueTimeUnits"
            :label="$t('components.duepicker.due_time_unit')"
            :rules="dueTimeUnitRules"
            :disabled="disabled"
          ></trans-enum>
        </v-col>
      </v-row>
    </v-col>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TransEnum from "../components/TransEnum.vue";
// import AutoSelect from "../components/AutoSelect";
export default {
  name: "due-picker",
  props: [
    "value",
    "disabled",
    "daysOfMonth",
    "dueDays",
    "months",
    "dueTimeUnits",
    "weekDays",
    "weeks",
    "termTimeUnit",
    "readOnly",
  ],
  components: {
    // AutoSelect,
    TransEnum,
  },
  mounted() {},
  data() {
    return {
      tooltips: {
        dueon: {
          show: false,
          text: this.$t("components.duepicker.dueon_tooltip"),
        },
      },
      dayOfMonthRules: [(v) => !!v || this.$t("validation.required")],
      dueDayRules: [
        (v) => !!v || this.$t("validation.required"),
        (v) => {
          //console.log(this.value.DueTimeUnit)
          if (this.value.DueTimeUnit === undefined) return false;
          if (this.value.DueTimeUnit === "Week")
            return (
              v === "WeekDay" || this.$t("validation.due_day_must_be_weekday")
            );
          else if (this.value.DueTimeUnit === "Month")
            return (
              v === "DayOfMonth" ||
              this.$t("validation.due_day_must_be_dayofmonth")
            );
          else return false;
        },
      ],
      monthRules: [(v) => !!v || this.$t("validation.required")],
      dueTimeUnitRules: [
        (v) => !!v || this.$t("validation.required"),
        (v) => {
          if (this.termTimeUnit === "Day" || this.termTimeUnit === "Week")
            return (
              v === "Week" || this.$t("validation.due_time_unit_must_be_week")
            );
          //console.log(this.value.DueDay)
          if (this.value.DueDay === "WeekDay")
            return (
              v === "Week" || this.$t("validation.due_time_unit_must_be_week")
            );
          else if (this.value.DueDay === "DayOfMonth")
            return (
              v === "Month" || this.$t("validation.due_time_unit_must_be_month")
            );
          else return false;
        },
      ],
      weekRules: [(v) => !!v || this.$t("validation.required")],
      weekDayRules: [(v) => !!v || this.$t("validation.required")],
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    dueTimeUnitsWeek() {
      return this.dueTimeUnits.filter((o) => o === "Week");
    },
    dueDaysWeek() {
      return this.dueDays.filter((o) => o === "WeekDay");
    },
  },
  watch: {
    "value.DueTimeUnit": {
      handler(v) {
        //console.log("DueTimeUnit: ", v);
        if (v === "Week") {
          this.value.DueDay = "WeekDay";
          this.value.DayOfMonth = null;
          this.value.Month = null;
        } else if (v === "Month") {
          this.value.DueDay = "DayOfMonth";
          this.value.WeekDay = null;
          this.value.Week = null;
        }
      },
    },
    "value.DueDay": {
      handler(v) {
        //console.log("DueTimeUnit: ", v);
        if (v === "WeekDay") {
          this.value.DueTimeUnit = "Week";
          this.value.DayOfMonth = null;
          this.value.Month = null;
        } else if (v === "DayOfMonth") {
          this.value.DueTimeUnit = "Month";
          this.value.WeekDay = null;
          this.value.Week = null;
        }
      },
    },
  },
  methods: {
    dueDayItems() {
      if (this.termTimeUnit === "Day" || this.termTimeUnit === "Week") {
        return this.dueDaysWeek;
      } else if (this.termTimeUnit === "Month") {
        return this.dueDays;
      }
    },
  },
};
</script>

<style>
.no-padding {
  padding: 0px;
}

.help-icon {
  align-self: center !important;
  font-size: 18px;
  padding-left: 5px;
}
</style>
<style scoped>
  .minfo {
    font-weight: bold;
    color: #222;
  }
  </style>
  
